module.exports = __webpack_public_path__ + "static/media/br-rj.5e39f759.svg";